import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { ListItem } from 'foundations-components/transitional/components/List';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { getManagePersonalizationVariantsUrl } from '../utils/PersonalizationVariantsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RunATestDisabledTooltip = ({
  isAnyTestRunning,
  isPersonalized,
  isDisabledDueToSmartContent = false,
  personalizationStrategyId
}) => {
  if (isAnyTestRunning) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
    });
  }
  if (isDisabledDueToSmartContent) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'mab.buttons.mab.disabledTooltip.smartContent'
    });
  }
  if (isPersonalized) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "div",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "consolidatedRunTestEntryPoints.genericDisabledTitle"
          })
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "div",
        color: "text-core-on-fill-default",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link
          },
          message: "consolidatedRunTestEntryPoints.disabledDueToPersonalization_jsx",
          options: {
            external: true,
            href: getManagePersonalizationVariantsUrl(personalizationStrategyId)
          }
        })
      })]
    });
  }
  return null;
};
export const RunATestOption = ({
  dataTestId,
  description,
  disabledToolTip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'mab.buttons.mab.disabledTooltip.hasTestRunning'
  }),
  isOptionDisabled,
  onClick,
  title
}) => /*#__PURE__*/_jsx(ListItem, {
  marginInlineEnd: "400",
  children: /*#__PURE__*/_jsx(Tooltip, {
    disabled: !isOptionDisabled,
    placement: "right",
    title: disabledToolTip,
    children: /*#__PURE__*/_jsx(SelectableButton, {
      block: true,
      "data-test-id": dataTestId,
      description: /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "400",
        textAlign: "start",
        children: description
      }),
      disabled: isOptionDisabled,
      onClick: onClick,
      selected: false,
      size: "large",
      title: /*#__PURE__*/_jsx(Text, {
        as: "div",
        textAlign: "start",
        typography: "heading-100",
        children: title
      }),
      marginBlock: "400",
      paddingBlockStart: "0"
    })
  })
});